import { render } from "./Cookies.vue?vue&type=template&id=18ad22cb&scoped=true"
import script from "./Cookies.vue?vue&type=script&lang=js"
export * from "./Cookies.vue?vue&type=script&lang=js"

import "./Cookies.vue?vue&type=style&index=0&id=18ad22cb&lang=scss"
import "./Cookies.vue?vue&type=style&index=1&id=18ad22cb&scoped=true&lang=scss"

import exportComponent from "/codebuild/output/src1376672443/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-18ad22cb"]])

export default __exports__